import { createContext, useContext, useState } from "react";
import PropTypes from "prop-types";
import api from "api/api";
import { ORDER } from "constants/ApiRoutes";

const OrderContext = createContext([]);

const OrderProvider = ({ children }) => {
  const [orderResponse, setOrderResponse] = useState([]);

  const storeOrder = async () => {
    await api.post(ORDER).then((response) => {
      setOrderResponse(response.data);
    });
  };

  const updateOrder = async (id, data, status) => {
    const payload = { status };

    if (data?.id) {
      payload.customer_id = data.id;
    }
    await api.put(`${ORDER}/${id}`, payload).then((response) => {
      setOrderResponse(response.data);
    });
  };

  return (
    <OrderContext.Provider
      value={{
        storeOrder,
        updateOrder,
        orderResponse,
        setOrderResponse,
      }}
    >
      {children}
    </OrderContext.Provider>
  );
};

const useOrder = () => {
  const context = useContext(OrderContext);
  if (!context) {
    throw new Error("useOrder must be used within a OrderProvider");
  }
  return context;
};

export { OrderProvider, useOrder };

OrderProvider.propTypes = {
  children: PropTypes.element,
};
